__turbopack_context__.v({
  "video-player-modal": "_6UAvMG_video-player-modal",
  "video-player-modal--open": "_6UAvMG_video-player-modal--open",
  "video-player-modal__container": "_6UAvMG_video-player-modal__container",
  "video-player-modal__container__content__title": "_6UAvMG_video-player-modal__container__content__title",
  "video-player-modal__container__video-player": "_6UAvMG_video-player-modal__container__video-player",
});
